import FilterTextInput from "../FilterTextInput";
import { FilterRemove } from "iconsax-react";
import { useNavigate } from "react-router-dom";
import { GUEST_LIST_IMPORT_LOG_DETAILS } from "../../Router/path";
import { motion as m } from "framer-motion";
import Paginator from "../Paginator";

const ImportLogTable = ({
  type,
  data,
  meta,
  handlePageClick,
  searchTerm,
  handleSearch,
  handleKeyDown,
  perPage,
  handlePerPageChange,
  clearFilter,
}) => {
  const navigate = useNavigate();

  return (
    <m.div
      className="flex flex-col border border-[#EFF0F2] w-full h-fit bg-white rounded-xl"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Filters */}
      <div className="flex w-full border-b border-[#EFF0F2] px-[24px] py-[12px] gap-[8px] items-center justify-end">
        {clearFilter && searchTerm !== "" && (
          <FilterRemove
            size="16"
            onClick={clearFilter}
            variant="Bold"
            className="text-[#FF3030] hover:cursor-pointer hover:text-[#5C4BF5]"
          />
        )}
        <FilterTextInput
          value={searchTerm}
          onChange={handleSearch}
          onKeyDown={handleKeyDown}
        />
      </div>

      {/* Table data */}
      {type === "list" ? (
        <div className="flex w-full h-full gap-[24px] overflow-x-auto">
          {!data || data.length === 0 ? (
            <div className="flex w-full h-[290px] items-center border-[#EFF0F2] justify-center text-gray-500 text-[25px]">
              No imports found
            </div>
          ) : (
            <table className="w-full h-full text-nowrap">
              {/* Table Header */}
              <tr className="w-full bg-[#F7F8F9] border-b border-[#EFF0F2]">
                <th className="text-start px-[24px] py-[16px]">File Name</th>
                <th className="text-start px-[24px] py-[16px]">Total Rows</th>
                <th className="text-start px-[24px] py-[16px]">
                  Successful Rows
                </th>
                <th className="text-start px-[24px] py-[16px]">Skipped Rows</th>
                <th className="text-start px-[24px] py-[16px]">Created At</th>
              </tr>

              {/* Table Body */}
              {data &&
                data.map((item) => (
                  <tr
                    key={item.id}
                    className="w-full font-normal border-b border-[#EFF0F2] last:border-none hover:bg-[#F7F8F9] cursor-pointer"
                    onClick={() => {
                      navigate(GUEST_LIST_IMPORT_LOG_DETAILS, {
                        state: { importId: item.id, fileName: item.file_name },
                      });
                    }}
                  >
                    <td className="px-[24px] py-[16px]">{item.file_name}</td>
                    <td className="px-[24px] py-[16px]">{item.total_rows}</td>
                    <td className="px-[24px] py-[16px]">
                      {item.successful_rows}
                    </td>
                    <td className="px-[24px] py-[16px]">{item.issues}</td>
                    <td className="px-[24px] py-[16px]">{item.created_at}</td>
                  </tr>
                ))}
            </table>
          )}
        </div>
      ) : (
        type === "details" && (
          <div className="flex w-full h-full gap-[24px] overflow-x-auto">
            {!data || data.length === 0 ? (
              <div className="flex w-full h-[290px] items-center border-[#EFF0F2] justify-center text-gray-500 text-[25px]">
                No issues found
              </div>
            ) : (
              <table className="w-full h-full text-nowrap">
                {/* Table Header */}
                <tr className="w-full bg-[#F7F8F9] border-b border-[#EFF0F2]">
                  <th className="text-start px-[24px] py-[16px]">Row</th>
                  <th className="text-start px-[24px] py-[16px]">
                    Reason/Error
                  </th>
                </tr>

                {/* Table Body */}
                {data &&
                  data.map((item) => (
                    <tr
                      key={item.id}
                      className="w-full font-normal border-b border-[#EFF0F2] last:border-none"
                    >
                      <td className="px-[24px] py-[16px]">{item.row_number}</td>
                      <td className="px-[24px] py-[16px]">
                        {item.validation_error}
                      </td>
                    </tr>
                  ))}
              </table>
            )}
          </div>
        )
      )}

      {/* Pagination */}
      {meta && (
        <Paginator
          meta={meta}
          perPage={perPage}
          handlePageClick={handlePageClick}
          handlePerPageChange={handlePerPageChange}
        />
      )}
    </m.div>
  );
};

export default ImportLogTable;
